import { useState } from "react";

interface UsePaginationProps {
  totalItems: number;
  itemsPerPage: number;
  initialPage?: number;
}

export const usePagination = <T>({
  totalItems,
  itemsPerPage,
  initialPage = 1,
}: UsePaginationProps): {
  page: number;
  totalPages: number;
  paginatedItems: (items: T[]) => T[];
  handlePageChange: (
    event: React.ChangeEvent<unknown>,
    newPage: number,
  ) => void;
} => {
  const [page, setPage] = useState(initialPage);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const paginatedItems = (items: T[]) =>
    items.slice((page - 1) * itemsPerPage, page * itemsPerPage) as T[];

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  return {
    page,
    totalPages,
    paginatedItems,
    handlePageChange,
  };
};
